import { Typography, IconButton, Tooltip, type SxProps } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

export function CopyId({ id, show = true, sx = {} }: { id?: string | null; show?: boolean; sx?: SxProps }) {
  if (!id || !show) return null;
  return (
    <Typography color="text.secondary" fontSize={14} sx={{ display: 'inline-flex', alignItems: 'center', ...sx }}>
      <Tooltip title="Copy">
        <IconButton size="small" onClick={() => navigator.clipboard.writeText(id)}>
          <ContentCopy sx={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
      {id}
    </Typography>
  );
}
